// extracted by mini-css-extract-plugin
export default {"root":"styles_root__9+J9o","body":"styles_body__k2qpr"};